import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  Input,
  message,
  Form,
  InputNumber,
  Select,
  Upload,
  Button,
  Switch,
  TreeSelect,
  Icon,
  Row,
  Col,
} from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cookie from 'js-cookie';
import xfetch from '../../../xfetch';
import { backendErrorTip } from '../../../utils';
import Context from '../../../components/Layout/Context';
import s from './style.css';

let id = 0;
const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    sm: {
      span: 16,
      offset: 6,
    },
  },
};

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    sm: { span: 16, offset: 6 },
  },
};

const { TextArea } = Input;
const FormItem = Form.Item;
const { Option } = Select;
const { TreeNode } = TreeSelect;

@withStyles(s)
class Setting extends Component {
  constructor(props) {
    super(props);
    this.user = {};
    this.baseApi = `${window.G.backendApi}/system/settings/`;
    this.uploadApi = `${window.G.backendApi}/system/image/`;
    this.orgTreeApi = `${window.G.backendApi}/profiles/organization/tree/`;
  }
  state = {
    item: {
      im_scripts: [],
    },
    items: [],
    treeNodes: [],
  };
  componentDidMount() {
    this.query();
    this.queryOrgTree();
  }
  query = () => {
    xfetch(this.baseApi).then(({ error, result }) => {
      if (error) {
        backendErrorTip(error);
        return;
      }
      const settings = result.length ? result[0] : {};
      this.setState(
        {
          item: settings,
          items: result || [],
        },
        () => {
          id = (settings.im_scripts || []).length;
        },
      );
    });
  };
  queryOrgTree = async () => {
    const { error, result } = await xfetch(this.orgTreeApi);
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      treeNodes: result.tree,
    });
  };
  // 切换组织
  changeOrg = organization => {
    const item = this.state.items.find(x => x.organization === organization);
    this.setState({
      item: item || {},
    });
  };
  updateItem = e => {
    e.preventDefault();
    const { item, items } = this.state;
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const { im_names, im_scripts = [], ...oValues } = values;
      const body = {
        ...oValues,
        im_scripts: im_scripts.map((x, i) => ({
          name: im_names[i],
          value: x,
        })),
        auto_train: values.auto_train ? 'on' : 'off',
      };
      const isSuper = this.user.role === 'superuser';
      // 子站管理员通过 mine 接口筛选org
      if (!isSuper) {
        const findItemByUser =
          items.find(x => x.organization === this.user.organization) || {};
        item.id = findItemByUser.id;
      }

      if (item.id) {
        xfetch(`${this.baseApi}${item.id}/`, {
          body,
          method: 'PATCH',
        }).then(({ error }) => {
          if (error) {
            backendErrorTip(error);
            return;
          }
          message.success('系统设置更新成功');
        });
      } else {
        xfetch(this.baseApi, {
          body,
          method: 'POST',
        }).then(({ error }) => {
          if (error) {
            backendErrorTip(error);
            return;
          }
          message.success('系统设置保存成功');
        });
      }
    });
  };
  deleteItem = async id => {
    await xfetch(`${this.baseApi}${id}/`, {
      method: 'DELETE',
    });
    this.q.page = 1;
    this.query();
  };
  renderTreeNodes = tree => {
    const data = Object.values(tree);
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            disabled={item.deprecated}
            key={item.id}
            value={item.id}
            title={item.name}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          value={item.id}
          disabled={item.deprecated}
          title={item.name}
        />
      );
    });
  };
  removeIMField = k => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    if (keys.length === 1) {
      return;
    }
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    });
  };

  addIMField = () => {
    const { form } = this.props;
    const keys = form.getFieldValue('keys');
    const nextKeys = keys.concat(id++);
    form.setFieldsValue({
      keys: nextKeys,
    });
  };
  render() {
    const { item, treeNodes } = this.state;
    const orgTreeNodes = this.renderTreeNodes(treeNodes);
    const uploadProps = {
      name: 'image',
      multiple: false,
      action: this.uploadApi,
      accept: '.png,.jpg,.jpeg',
      headers: {
        Authorization: `jwt ${cookie.get('AUTH')}`,
      },
      onChange: info => {
        if (info.file.status === 'error') {
          backendErrorTip(`${info.file.name} 上传失败`);
          return;
        }
        if (info.file && info.file.response) {
          const robotAvatar = info.file.response.image;
          this.props.form.setFieldsValue({
            robot_avatar: robotAvatar,
          });
        }
      },
    };
    const {
      logo,
      title,
      organization,
      robot_avatar: robotAvatar,
      theme,
      enabled_themes: enabledThemes = [],
      auto_train: autoTrain,
      hello_word: helloWord,
      best_answer_score: bestAnswerScore,
      im_scripts = [],
    } = item;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    getFieldDecorator('keys', { initialValue: im_scripts.map((x, i) => i) });

    const keys = getFieldValue('keys');
    const formItems = keys.map((k, index) => (
      <Row>
        <div className="ant-col ant-form-item-label ant-col-sm-6">
          {index === 0 ? <label>人工客服代码设置</label> : null}
        </div>
        <Col span={16}>
          <Row gutter={20}>
            <Col span={7}>
              <Form.Item required={false} key={`${k}1`}>
                {getFieldDecorator(`im_names[${k}]`, {
                  initialValue: im_scripts[index] ? im_scripts[index].name : '',
                })(
                  <Input
                    placeholder="客服名称"
                    style={{ width: '100%', marginRight: 8 }}
                  />,
                )}
              </Form.Item>
            </Col>
            <Col span={17}>
              <Form.Item
                label=""
                required={false}
                key={`${k}2`}
                extra={
                  <div>
                    请前往&nbsp;
                    <a
                      href="https://shang.qq.com/v3/widget.html"
                      target="_blank"
                      rel="noreferrer"
                    >
                      https://shang.qq.com/v3/widget.html
                    </a>
                    &nbsp;开通QQ推广功能，并把代码复制到此处
                  </div>
                }
              >
                {getFieldDecorator(`im_scripts[${k}]`, {
                  initialValue: im_scripts[index]
                    ? im_scripts[index].value
                    : '',
                })(
                  <Input.TextArea
                    rows={4}
                    placeholder={`客服代码，如：<a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=51365091&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:51365091:52" alt="转人工" title="转人工" /></a>`}
                    style={{ width: '100%', marginRight: 8 }}
                  />,
                )}
                {keys.length > 1 ? (
                  <Icon
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    onClick={() => this.removeIMField(k)}
                  />
                ) : null}
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>
    ));
    return (
      <Context.Consumer>
        {context => {
          this.user = context.user;
          return (
            <Form className={s.wrap} onSubmit={this.updateItem}>
              {getFieldDecorator('logo', {
                initialValue: logo,
              })(<Input type="hidden" />)}
              {context.user && context.user.role === 'superuser' && (
                <FormItem label="组织机构" {...formItemLayout}>
                  {getFieldDecorator('organization', {
                    rules: [{ required: true, message: '请输入机构名称' }],
                    initialValue: organization,
                  })(
                    <TreeSelect
                      showSearch
                      onChange={this.changeOrg}
                      style={{ width: '100%' }}
                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                      placeholder="请选择"
                      allowClear
                      treeDefaultExpandAll
                    >
                      {orgTreeNodes}
                    </TreeSelect>,
                  )}
                </FormItem>
              )}
              <FormItem label="产品名称" {...formItemLayout}>
                {getFieldDecorator('title', {
                  rules: [{ required: true, message: '请输入产品名称' }],
                  initialValue: title,
                })(<Input />)}
              </FormItem>
              <FormItem label="机器人头像" {...formItemLayout}>
                {getFieldDecorator('robot_avatar', {
                  rules: [{ required: true, message: '请上传机器人头像' }],
                  initialValue: robotAvatar,
                })(
                  <div>
                    <Upload {...uploadProps}>
                      <Button icon="upload">上传机器人头像</Button>
                    </Upload>
                    <img
                      alt=""
                      src={getFieldValue('robot_avatar')}
                      width="100"
                      height="100"
                    />
                  </div>,
                )}
              </FormItem>
              {Object.keys(item).length ? (
                <FormItem label="开启自动学习" {...formItemLayout}>
                  {getFieldDecorator('auto_train', {
                    rules: [{ required: true, message: '请选择' }],
                    initialValue: autoTrain,
                  })(<Switch defaultChecked={autoTrain === 'on'} />)}
                </FormItem>
              ) : null}
              <FormItem label="最佳答案分值阈值" {...formItemLayout}>
                {getFieldDecorator('best_answer_score', {
                  rules: [
                    { required: true, message: '最选择最佳答案分值阈值' },
                  ],
                  initialValue: bestAnswerScore || 0.4,
                })(<InputNumber min={0.001} max={0.999} step={0.1} />)}
              </FormItem>
              <FormItem label="主题" {...formItemLayout}>
                {getFieldDecorator('theme', {
                  rules: [{ required: true, message: '请选择主题' }],
                  initialValue: theme || 'blue',
                })(
                  <Select
                    showSearch
                    dropdownMatchSelectWidth
                    placeholder="请选择"
                    style={{ width: '250' }}
                    filterOption={(inputValue, option) =>
                      option.props.children.indexOf(inputValue) > -1
                    }
                  >
                    {enabledThemes.map(x => (
                      <Option key={x[0]} value={x[0]}>
                        {x[1]}
                      </Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
              <FormItem label="机器人欢迎语" {...formItemLayout}>
                {getFieldDecorator('hello_word', {
                  rules: [{ required: true, message: '请输入机器人欢迎语' }],
                  initialValue:
                    helloWord ||
                    '您好！我是政AI政务机器人，为您提供智能咨询服务，请问有什么可以帮您？',
                })(<TextArea rows={4} />)}
              </FormItem>
              {formItems}
              <Form.Item {...formItemLayoutWithOutLabel}>
                <Button
                  type="dashed"
                  onClick={this.addIMField}
                  style={{ width: '60%' }}
                >
                  <Icon type="plus" /> 添加人工客服
                </Button>
              </Form.Item>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit" size="large">
                  保存
                </Button>
              </FormItem>
            </Form>
          );
        }}
      </Context.Consumer>
    );
  }
}

Setting.propTypes = {
  form: PropTypes.shape().isRequired,
};

export default Form.create()(Setting);
